// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"Illustration_illustrationContainer__F6WHY","illustrationTitle":"Illustration_illustrationTitle__AhyWz"};